export default __webpack_public_path__ + "static/yangol-casestudy-cover-c1823f74dfda838a708d839d6249699d.png";